import React from "react";

export default function SubtitleFooter({ elem }) {
  return (
    <div>
      <h6 className="subtitleFooter">{elem.label}</h6>
    </div>
  );
}
